import { render } from "./ViewContact.vue?vue&type=template&id=34dc561b&scoped=true"
import script from "./ViewContact.vue?vue&type=script&lang=js"
export * from "./ViewContact.vue?vue&type=script&lang=js"

import "./ViewContact.vue?vue&type=style&index=0&id=34dc561b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34dc561b"]])

export default __exports__